import { ChangeEvent, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputGroup } from '@blueprintjs/core';
import { debounceFunction } from '@axo/shared/util/fp';
import CollapsableButton from './CollapsableButton';
import {
  useQuickSearchActions,
  useQuickSearchQuery,
  useSearchTabActions,
} from '../../store';
import styles from './SearchBar.module.css';

interface Props {
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
}

const SearchBar = ({ collapsed, setCollapsed }: Props) => {
  const query = useQuickSearchQuery();
  const { replaceQuery } = useQuickSearchActions();
  const { selectTab } = useSearchTabActions();

  const navigate = useNavigate();

  const onChangePhone = useMemo(
    () =>
      debounceFunction((event: ChangeEvent<HTMLInputElement>) => {
        replaceQuery((query) => ({
          ...query,
          CustomerMobilePhoneNumber: event.target.value,
        }));

        selectTab('quick-search');
        navigate('/search');
      }, 500),
    [navigate, replaceQuery, selectTab],
  );

  return (
    <CollapsableButton
      collapsed={collapsed}
      icon="search"
      onClick={() => setCollapsed(false)}
    >
      <InputGroup
        className={styles.searchBar}
        placeholder="Search by phone number"
        asyncControl={true}
        leftIcon="search"
        type="search"
        value={query.CustomerMobilePhoneNumber ?? ''}
        onFocus={() => setCollapsed(false)}
        onChange={onChangePhone}
      />
    </CollapsableButton>
  );
};

export default SearchBar;
